export default "__VITE_ASSET__CdQyZKQG__"